<div class="card shadow-sm">
  <div class="card-body device-card">
    <div class="row d-flex justify-content-center justify-content-between card-title">
      <h4 class="col-6">{{ 'your_cart' | translate }}</h4>

      @if (shopping_cart && shopping_cart.carrier) {
        <div class="col-6 d-flex flex-column align-items-end">
          <img
            #carrier_img
            class="img-fluid carrier-img"
            src="{{ shopping_cart.carrier.image_url }}"
            [hidden]="carrier_img.hidden"
            [alt]="shopping_cart.carrier.name"
            (error)="carrier_img.hidden = true"
          />
          <h6 class="pt-2 text-secondary text-end">
            {{ shopping_cart.carrier.name }}
          </h6>
        </div>
      }
    </div>

    <div class="row g-3">
      @for (cart_item of cart_items; track cart_item) {
        <div class="col col-12">
          <div class="card overflow-hidden">
            <div
              [ngClass]="[
                'card-body card-items  card-items-spacer-y-2',
                cart_item.type === 'ACCESSORY' || cart_item.type === 'DEVICE'
                  ? 'card-items-height-auto'
                  : 'card-items-sm'
              ]"
            >
              <div class="row d-flex justify-content-center justify-content-sm-between">
                <div
                  class="col col-12 col-sm-2 text-center item-image"
                  [ngClass]="{
                    'bg-white': cart_item.type === 'ACCESSORY' || cart_item.type === 'DEVICE'
                  }"
                >
                  <img
                    [alt]="cart_item.name"
                    src="{{ cart_item.image_url }}"
                    (error)="generatePlaceholderImage($event, cart_item)"
                  />
                </div>
                <div class="col col-12 col-sm-5 col-lg-7 text-center text-sm-start">
                  <h5 class="mb-1 line-clamp-2">
                    {{ cart_item.name }}
                  </h5>
                  @if (cart_item.type === cart_item_types[0]) {
                    <h6 class="text-secondary">
                      {{ cart_item.description }}
                    </h6>
                    @if (cart_item.additional_info?.business_purpose) {
                      <h6 class="text-secondary">
                        {{ cart_item.additional_info?.business_purpose }}
                      </h6>
                    }
                    @if (cart_item.additional_info?.option) {
                      <h6 class="text-secondary">
                        {{ 'option' | translate }}: {{ cart_item.additional_info?.option }}
                      </h6>
                    }
                  }
                  <div class="d-flex justify-content-center justify-content-sm-start">
                    @if (isDisplayEdit(cart_item)) {
                      <button
                        class="btn btn-link text-capitalize neutral-btn fw-light text-decoration-underline focus-visible"
                        (click)="navigateToDetailsPage(cart_item)"
                      >
                        {{ 'edit' | translate }}
                      </button>
                      @if (hasRemovableCartItems(cart_item)) {
                        <div class="vr mx-1"></div>
                      }
                    }
                    @if (hasRemovableCartItems(cart_item)) {
                      <button
                        class="btn btn-link text-capitalize neutral-btn fw-light text-decoration-underline focus-visible"
                        (click)="removeCartItem(cart_item)"
                      >
                        {{ 'remove' | translate }}
                      </button>
                    }
                  </div>
                  @if (cart_item.type === cart_item_types[3]) {
                    <div class="d-flex justify-content-center justify-content-sm-start mt-1">
                      <small class="text-secondary mt-2 me-2">{{ 'qty' | translate }}:</small>
                      <select
                        #accessoryQuantity
                        [id]="cart_item.name"
                        class="d-inline-block form-select form-select-sm w-auto"
                        (change)="
                          onSelectChange(cart_item, accessoryQuantity.value, cart_item.name!)
                        "
                      >
                        @for (quantity of accessory_selection; track quantity) {
                          <option
                            [value]="quantity.value"
                            [selected]="quantity.value == cart_item.quantity"
                          >
                            {{ quantity.name }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                </div>
                <div class="col col-12 col-sm-4 col-lg-3 text-center text-sm-end">
                  <div class="row justify-content-sm-end">
                    @if ([cart_item_types[1], cart_item_types[2]].includes(cart_item.type)) {
                      <div class="col-12 col-sm-6 p-1">
                        <div
                          class="d-flex flex-column flex-xl-row justify-content-center align-items-center mb-3 mb-sm-0"
                        >
                          @if (cart_item.additional_info?.included) {
                            <ts-badge class="me-xl-2" text="{{ 'included' | translate }}" />
                          }
                          @if (keep_plan) {
                            <ts-badge
                              [class]="cart_item.additional_info?.included ? 'mt-2 mt-xl-0' : ''"
                              text="{{ 'unchanged' | translate }}"
                            />
                          }
                        </div>
                      </div>
                    }
                    <div class="col-12 col-sm-6">
                      @if (cart_item.onetime_cost_to_currency) {
                        <h5>
                          @if (cart_item.type === cart_item_types[3]) {
                            <span>
                              {{ cart_item.total_one_time_cost_to_currency }}
                            </span>
                          } @else {
                            {{ cart_item.onetime_cost_to_currency }}
                          }
                        </h5>
                      }
                      @if (
                        cart_item.type == cart_item_types[1] || cart_item.type == cart_item_types[2]
                      ) {
                        <h5 class="mb-0">
                          {{ cart_item.monthly_cost_to_currency }}
                        </h5>
                      }
                      @if (
                        cart_item.type == cart_item_types[0] && cart_item.monthly_cost_to_currency
                      ) {
                        <div
                          class="d-flex justify-content-center justify-content-sm-end flex-column flex-sm-row"
                        >
                          <h6>
                            <span class="text-secondary"> {{ 'plus' | translate }}&nbsp; </span>
                            <span>{{ cart_item.monthly_cost_to_currency }}</span>
                            <span>/mo</span>
                          </h6>
                        </div>
                      } @else {
                        @if (
                          cart_item.type == cart_item_types[1] ||
                          cart_item.type == cart_item_types[2]
                        ) {
                          <small class="text-secondary lh-base d-block mb-0">
                            {{ 'per_month' | translate }}
                          </small>
                        }
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (bulk_order_info.is_bulk_order) {
      <div class="row flex-column mt-3">
        <div class="col">
          <div class="row justify-content-start">
            <form class="col col-sm-4 align-content-center" [formGroup]="bulk_order_form">
              <label for="BulkQuantityInput" class="form-label required fw-medium me-2">
                {{ 'bulk_quantity' | translate }}
              </label>
              <input
                required
                id="BulkQuantityInput"
                class="form-control has-validation d-inline-block w-25"
                [class.is-invalid]="
                  !bulk_order_form.valid && bulk_order_form.dirty && bulk_order_form.touched
                "
                type="text"
                name="bulk_quantity"
                formControlName="bulkQuantity"
                (blur)="bulk_quantity_entered(bulk_order_form.controls['bulkQuantity'].value)"
              />
            </form>
          </div>
        </div>
        <div class="col">
          @if (bulk_order_form.controls['bulkQuantity'].errors) {
            <span class="d-flex flex-column text-danger">
              @if (
                bulk_order_form.dirty &&
                bulk_order_form.touched &&
                bulk_order_form.controls['bulkQuantity'].errors
              ) {
                <small>
                  {{ 'bulk_quantity_error' | translate }}
                </small>
              }
            </span>
          }
          <small class="d-inline-block fw-light text-secondary">
            {{
              'enter_bulk_quantity'
                | translate
                  : [bulk_order_info.min_value!.toString(), bulk_order_info.max_value!.toString()]
            }}
          </small>
        </div>
      </div>
    }
  </div>
</div>
